<template>
  <!-- 产品服务-车源采集 -->
  <div class="box cj">
    <div v-if="!isM" class="cj0 bgimg"></div>
    <div v-if="isM" class="cjm0"></div>

    <div class="cj1">
      <div class="min_box">
        <h4 class="blue_h4">集采车源+仓储前置模式</h4>
        <p class="gary_dec">提高流通效率，为车商降本增效</p>
        <img class="wlphobe" :src="picUrl + 'cjlist.png'" alt="车源采集" />
      </div>
    </div>

    <div class="cj2">
      <div class="min_box">
        <h4 class="blue_h4">核心优势</h4>
        <ul class="cj_ul">
          <li v-for="(item, index) in arr" :key="item.id">
            <img
              :src="picUrl + 'cji' + (index + 1) + '.png'"
              :alt="item.name"
            />
            <div>
              <p>{{ item.tit }}</p>
              <span>{{ item.dec }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="cj3">
      <div class="min_box">
        <h4 class="blue_h4">车商集采 铺车到店</h4>
        <p class="gary_dec">利用上游资源优势，整合下游车商采购需求</p>
        <ul class="cj3_ul">
          <li v-for="item in 3" :key="item">
            <img :src="picUrl + 'cj' + item + '.jpg'" alt="车源采集" />
          </li>
        </ul>
      </div>
    </div>

    <div class="cj4">
      <div class="min_box">
        <div>
          <h4 class="blue_h4">全国布局 渠道下沉</h4>
          <p class="gary_dec">
            广东、广西、云南、贵州、四川、西藏、青海、
            湖南、湖北、重庆、江西等30个前置仓覆盖
          </p>
        </div>

        <img class="wlmap" :src="picUrl + 'cjmap.png'" alt="车源采集" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cycj",
  data() {
    return {
      picUrl: this.$root.picUrl,
      arr: [
        {
          tit: "集中批量采购",
          dec: "车源成本更低",
        },
        {
          tit: "前置仓就近调拨",
          dec: "流通速度更快",
        },
        {
          tit: "专业验车流程",
          dec: "质量更有保障",
        },
        {
          tit: "最短时间交车",
          dec: "购车体验更好",
        },
      ],
      isM: false,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Proservices/cycj.vue